// extracted by mini-css-extract-plugin
module.exports = {"min":"jut__SliderIndicatorsContainer__min","max":"jut__SliderIndicatorsContainer__max"};